var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartLine',{attrs:{"datasets":_vm.defaultDatasets,"labels":_vm.label,"options":{ maintainAspectRatio: true }}})
}
var staticRenderFns = []

export { render, staticRenderFns }